const DICTIONARIES = {
  en: {
    address: 'Company Address',
    contact_department: 'Contact Department',
    contact_details: 'Contact Details',
    contact_division: 'Contact Division',
    contact_email: 'Contact Email',
    contact_email_abbr: 'C. Email Address',
    contact_name: 'Contact Name',
    contact_phone_number: 'Contact Number',
    contact_phone_number_abbr: 'C. Phone Number',
    contact_position: 'Contact Position',
    details: 'Company Details',
    industry: 'Industry',
    pic_phone_number: 'PIC Phone Number',
    sales_channel: 'Sales Channel',
    sales_name: 'Sales Name',
  },
};

export default DICTIONARIES;
